import { Platform, TextStyle } from 'react-native';

export type FontWeight = 'regular' | 'medium' | 'semibold' | 'bold';

export default Platform.select<Record<FontWeight, TextStyle>>({
  web: {
    regular: {
      fontFamily: 'NotoSans, Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif',
      fontWeight: '400',
    },
    medium: {
      fontFamily: 'NotoSans, Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif',
      fontWeight: '500',
    },
    semibold: {
      fontFamily: 'NotoSans, Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif',
      fontWeight: '600',
    },
    bold: {
      fontFamily: 'NotoSans, Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif',
      fontWeight: '700',
    },
  },
  ios: {
    regular: {
      fontFamily: 'NotoSans-Regular',
      fontWeight: 'normal',
    },
    medium: {
      fontFamily: 'NotoSans-Medium',
      fontWeight: '500',
    },
    semibold: {
      fontFamily: 'NotoSans-SemiBold',
      fontWeight: '600',
    },
    bold: {
      fontFamily: 'NotoSans-Bold',
      fontWeight: '700',
    },
  },
  default: {
    regular: {
      fontFamily: 'NotoSans-Regular',
      fontWeight: '400',
    },
    medium: {
      fontFamily: 'NotoSans-Medium',
      fontWeight: '500',
    },
    semibold: {
      fontFamily: 'NotoSans-SemiBold',
      fontWeight: '600',
    },
    bold: {
      fontFamily: 'NotoSans-Bold',
      fontWeight: '700',
    },
  },
});
